import { render, staticRenderFns } from "./DialogExcluirRodadaCompra.vue?vue&type=template&id=9ac7b260&scoped=true"
import script from "./DialogExcluirRodadaCompra.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogExcluirRodadaCompra.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogExcluirRodadaCompra.vue?vue&type=style&index=0&id=9ac7b260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac7b260",
  null
  
)

export default component.exports